<div mat-dialog-title>
    <h2>{{ editing ? 'Edit Document' : 'Add Document' }}</h2>
    <p>{{ editing ? 'Update the document details and visibility.' : 'Upload an operational document for this record.' }}</p>
</div>

<div mat-dialog-content>
    <div class="document-form-grid">
        <mat-form-field appearance="outline">
            <mat-label>Category</mat-label>
            <mat-select [(value)]="selectedCategory" [disabled]="uploading">
                @for (category of categories; track category) {
                    <mat-option [value]="category">{{ category }}</mat-option>
                }
            </mat-select>
        </mat-form-field>

        @if (selectedCategory === 'Other') {
            <mat-form-field appearance="outline">
                <mat-label>Custom category</mat-label>
                <input matInput [(ngModel)]="customCategory" [disabled]="uploading" maxlength="125" />
            </mat-form-field>
        }

        <mat-form-field appearance="outline">
            <mat-label>Title</mat-label>
            <input matInput [(ngModel)]="title" [disabled]="uploading" maxlength="125" />
        </mat-form-field>
    </div>

    <section class="document-visibility-fields" *appCan="'manage_document_visibility'">
        <span>Visible to</span>
        <mat-button-toggle-group multiple aria-label="Document visibility">
            <mat-button-toggle [checked]="visibleToCustomer" [disabled]="uploading" (change)="visibleToCustomer = $event.source.checked">Customer</mat-button-toggle>
            <mat-button-toggle [checked]="visibleOnApp" [disabled]="uploading" (change)="visibleOnApp = $event.source.checked">App</mat-button-toggle>
            <mat-button-toggle [checked]="includeInReport" [disabled]="uploading" (change)="includeInReport = $event.source.checked">Report</mat-button-toggle>
        </mat-button-toggle-group>
    </section>

    @if (!editing) {
        <input #fileInput type="file" hidden (change)="selectFiles(fileInput.files)" />
        <div class="document-dropzone" fileDragDrop (filesChangeEmiter)="selectFiles($event)" [class.document-uploading]="uploading" role="button" tabindex="0" (click)="!uploading && fileInput.click()" (keydown.enter)="!uploading && fileInput.click()" (keydown.space)="!uploading && fileInput.click()">
            <mat-icon>upload_file</mat-icon>
            <span>Drop a document here or click to browse</span>
            <small>Maximum file size: 25 MB</small>
        </div>

        @if (selectedFile) {
            <div class="document-selected-file">
                <mat-icon>description</mat-icon>
                <span>{{ selectedFile.name }}</span>
                <button mat-icon-button type="button" aria-label="Remove selected file" [disabled]="uploading" (click)="removeFile()"><mat-icon>close</mat-icon></button>
            </div>
        }
    }
</div>

<div mat-dialog-actions align="end">
    <button mat-stroked-button type="button" [disabled]="uploading" (click)="dialogRef.close()">Cancel</button>
    <button mat-raised-button color="primary" type="button" [disabled]="uploading" (click)="submit()">
        {{ uploading ? (editing ? 'Saving…' : 'Uploading…') : (editing ? 'Save Changes' : 'Add Document') }}
    </button>
</div>
